export default __webpack_public_path__ + "static/media/take-away.6f19ac9a.svg";